import PropTypes from "prop-types";
import React, { Component, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
	Button,
	Icon,
	Image,
	Container,
	Grid,
	Segment,
	Header
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import user_model from "models/user_model";
import UserReferral from "views/UIelems/UserReferral";
import org_model from "models/org_model";
import HomepageRich from "./HomepageRich";

const goto_start = () => {
	app.history.push("/cat");
};

// 		--------------------------------		--------------------------------		---------
// 		--------------------------------		--------------------------------		---------

const home_pharm_render = () => (
	<Container className="homepage">
		<BasicIntro />
		<h3>
			WeWordle is a fun multiplayer word puzzle game that you can play
			with friends and compete on global leaderboards.
		</h3>
		<h3>
			Challenge yourself with daily puzzles and real-time word battles
			against players from around the world.
		</h3>

		<br />
		<br />
		<div className="action-btns" align="center">
			{/*<Button color="green" size="huge" onClick={ _=>goto_start() }>
				Get Started
				<Icon name="right arrow" />
			</Button>*/}
			<Button color="green" size="huge" as={Link} to="/cat">
				Get Started
				<Icon name="right arrow" />
			</Button>
			<Button primary size="huge" as={Link} to={"/about"}>
				About
			</Button>
		</div>
	</Container>
);

// 		--------------------------------		--------------------------------		---------


const home_nurse_render = () => (
	<Container className="homepage">
		<BasicIntro />
		<br />
		<br />
		<div
			className="action-btns"
			style={{ display: "flex", justifyContent: "space-evenly" }}
			align="center"
		>
			{/*<Button color="green" size="huge" onClick={ _=>goto_start() }>
				Get Started
				<Icon name="right arrow" />
			</Button>*/}
			<Button color="green" size="huge" as={Link} to={app.consts.routes.cat_route+'/' + org_model.org_conf_itm(app.user.org, 'meds')}>
				New Script Request
				<Icon name="right arrow" />
			</Button>
			<Button color="orange" size="huge" as={Link} to="/patients">
				Returning Patient
				<Icon name="right arrow" />
			</Button>
			<Button primary size="huge" as={Link} to="/scripts/list">
				View My Scripts
			</Button>
		</div>
	</Container>
);

// 		--------------------------------		--------------------------------		---------

const home_mang_render = () => (
	<Container className="homepage">
		<BasicIntro />
		<br />
		<br />
		<div
			className="action-btns"
			style={{ display: "flex", justifyContent: "space-evenly" }}
			align="center"
		>
			<Button color="green" size="huge" as={Link} to="/scripts/list">
				View My Scripts
				<Icon name="right arrow" />
			</Button>
		</div>
	</Container>
);

// 		--------------------------------		--------------------------------		---------

const BasicIntro = () => {

	return (
		<div className="ww-homepage">
			{/* Hero Section */}
			<div className="ww-hero">
					<Image
						bordered={false}
						src={app.runtime.logo}
						className="ww-hero-logo"
					/>
				{/*<h1 className="ww-hero-title">WeWordle</h1>*/}
				<p className="ww-hero-tagline">The Ultimate Multiplayer Word Puzzle Experience</p>
				<p className="ww-hero-subtitle">Challenge friends, climb the leaderboard, become the word master</p>

				<div className="ww-hero-buttons">
					<Button className="ww-btn-primary" size="huge" as={Link} to="/game">
						Play Now
						<Icon name="play" />
					</Button>
					<Button className="ww-btn-secondary" size="huge" as={Link} to="/add/game">
						Create Game
						<Icon name="plus" />
					</Button>
				</div>
			</div>

			{/* Features Section */}
			<div className="ww-features">
				<div className="ww-feature-card">
					<Icon name="gamepad" size="huge" />
					<h3>Multiplayer Fun</h3>
					<p>Challenge friends and family to word battles in real-time</p>
				</div>
				<div className="ww-feature-card">
					<Icon name="trophy" size="huge" />
					<h3>Compete & Win</h3>
					<p>Climb the global leaderboards and prove your word skills</p>
				</div>
				<div className="ww-feature-card">
					<Icon name="lightning" size="huge" />
					<h3>Quick Games</h3>
					<p>Fast-paced rounds perfect for a quick brain workout</p>
				</div>
			</div>

			{/* How to Play Section */}
			<div className="ww-how-to-play">
				<h2>How to Play</h2>
				<div className="ww-steps">
					<div className="ww-step">
						<span className="ww-step-number">1</span>
						<p>Guess the hidden word in 5 tries or less</p>
					</div>
					<div className="ww-step">
						<span className="ww-step-number">2</span>
						<p>Green means correct letter in correct spot</p>
					</div>
					<div className="ww-step">
						<span className="ww-step-number">3</span>
						<p>Yellow means correct letter in wrong spot</p>
					</div>
					<div className="ww-step">
						<span className="ww-step-number">4</span>
						<p>Race against the clock and your friends!</p>
					</div>
				</div>
			</div>

			{/* Call to Action */}
			<div className="ww-cta">
				<h2>Ready to test your vocabulary?</h2>
				<Button className="ww-btn-primary" size="massive" as={Link} to="/game">
					Start Playing
					<Icon name="arrow right" />
				</Button>
			</div>
		</div>
	);
};
// 		--------------------------------		--------------------------------		---------


const Homepage = ({popup}) => {
	const host = location.host
	const is_pharm = app.state.loaded && app.dvc.org.type=='pharm'
	const is_cosm = app.dvc.org.type=='cosm' && user_model.check_access('nurse')
	const is_mang = user_model.check_any(['admin','doc','mang','nurse','pharm'])

	useEffect(_=>{
		if (popup) {
			app.trigger(app.events.SHOW_POPUP, popup)
		}
		
		app.settings.wwapp && location.pathname.includes('/contact-us') && app.trigger(
		  app.events.SHOW_POPUP, {
			"tp": "pu",
			"pt": "contact",
			"txt": "Contact Us",
			"u": "contact-us",
			"pn": "contact-us",
			"target":"iscr"
		})
		
	},[popup])

	return (
		<React.Fragment>
			<Helmet titleTemplate={app.settings.wwapp ? null : `%s – ${app.runtime.name}`}>
				<title>{app.settings.wwapp ? `WeWordle - Multiplayer Word Puzzle Game` : 'Home'}</title>
			</Helmet>
			{ 
				is_pharm &&  home_pharm_render()
				|| is_cosm && home_nurse_render()
				|| app.acl.is_doc_presc && home_nurse_render()
				// || is_mang && home_mang_render()
				|| BasicIntro()
				// || <HomepageRich />
			}

		</React.Fragment>
		
	);
};

export default Homepage;
